import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import SummaryHeader from "components/header/SummaryHeader";
import SelectOption from "components/select/SelectOption";
import AbsenceSummaryCard from "./components/AbsenceSummaryCard";
import HeaderComponent from "components/card/HeaderComponent";
import AbsencesCard from "./components/AbsencesCard";
import { 
  getLeaveList, getLeaveStat
} from "../../../../redux/leave/leaveState";
import { 
  getCountryList, getDepartmentList, getLeaveStateList,
} from "../../../../redux/optionlist/optionlistState";
import { handleTableChange } from "utils";
import { Pagination } from "antd";
import { displayIcon } from "variables/icons";


const TeamAbsences = ({ }) => {

  const dispatch = useDispatch();

  const recordList = useSelector((state) => state.leave.leaveList?.items);
  const recordStat = useSelector((state) => state.leave.leaveStat.data);
  const pagination = useSelector((state) => state.leave.leaveList?.pagination);
  const filters = useSelector((state) => state.leave.leaveList.filters);
  const countryList = useSelector((state) => state.optionlist.countryList?.items);
  const departmentList = useSelector((state) => state.optionlist.departmentList?.items);
  const leaveStateList = useSelector((state) => state.optionlist.leaveStateList?.items);

  const doSearch = (filters) => dispatch(getLeaveList(filters));


  useEffect(() => {
    dispatch(getCountryList());
    dispatch(getDepartmentList());
    dispatch(getLeaveStateList());
    dispatch(getLeaveStat());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getLeaveList({paginate: pagination.per_page}));
  }, [dispatch, pagination.per_page]);

  const onSelectFilter = (field, value) => {
    const data = {
      ...(filters || {}),
      page: 1,
      paginate: pagination?.per_page || 10,
    };

    if (value && value !== "all") {
      data[field] = value;
    } else {
      delete data[field];
    }
    
    doSearch(data);
  };



  return (
    <div className="flex flex-col gap-6">
      <SummaryHeader
        title="Team Absences Overview"
        iconName="UserX"
        description="Monitor team member absences and leave schedules"
        color="violet"
      />
      <AbsenceSummaryCard
        currentlyOut={recordStat?.currently_out }
        upcomingThisWeek={recordStat?.upcoming_this_week }
        upcomingThisMonth={recordStat?.upcoming_this_month }
        totalDays={recordStat?.total_days }
      />
      <Card className="rounded-xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          <SelectOption
            placeholder="All Departments"
            options={departmentList}
            value={filters?.department_id || "all"}
            onChange={(value) => onSelectFilter("department_id", value)}
          />

          <SelectOption
            placeholder="All Locations"
            options={countryList}
            value={filters?.country_id || "all"}
            onChange={(value) => onSelectFilter("country_id", value)}
          />

          <SelectOption
            placeholder="All Status"
            options={leaveStateList}
            value={filters?.lve_state || "all"}
            onChange={(value) => onSelectFilter("lve_state", value)}
          />
        </div>
      </Card>


      <HeaderComponent
        title="Team Member Absences"
        description={`Showing ${recordList?.length || 0} absences`}
      >
        <div className="pr-2">
          <div className="space-y-4">
            {recordList && recordList.length > 0 ? (
              recordList.map((leave) => 
                <AbsencesCard 
                  key={leave?.lve_id} 
                  {...leave}
                  onChange={handleTableChange(doSearch, filters)}
                />)
            ) : (
              <div className="text-center py-12">
                {displayIcon('Users', "w-12 h-12 text-slate-700 mx-auto mb-4 dark:text-slate-100")}
                <p className="text-slate-700 dark:text-slate-100">No absences found matching the filters</p>
              </div>
            )}
          </div>
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination.current_page}
              pageSize={pagination.per_page}
              total={pagination.total}
              showSizeChanger={false}
              onChange={(page) =>
                doSearch({
                  ...filters,
                  page,
                  paginate: pagination.per_page,
                })
              }
            />
          </div>
        </div>
      </HeaderComponent>
    </div>
  );
};

export default TeamAbsences;
